import * as R from "ramda";
import React from "react";
import {
  List,
  Datagrid,
  DateField,
  FunctionField,
  NumberField,
  TextField,
  ShowButton,
  SimpleShowLayout,
  BooleanField,
} from "react-admin";
import {
  DoctorReferenceField,
  PatientReferenceField,
} from "../../misc/customFields";
import { completedSessionExporter } from "../../misc/exports.js";
import { SessionFilter } from "../../misc/filters";
import {TheragunDevicesAside} from "./DevicesAside";
import SessionShow from "./utils";

import withStyles from "@material-ui/core/styles/withStyles";

const listStyles = {
  card: {
    "& div": {
      justifyContent: "flex-start",
    },
  },
};

export const TheragunCompletedSessionList = withStyles(listStyles)(
  ({ classes, ...props }) => (
    <List
      classes={classes}
      {...props}
      exporter={completedSessionExporter}
      filters={<SessionFilter />}
      bulkActionButtons={null}
    >
      <Datagrid {...props}>
        <ShowButton />
        <TextField source="id" />
        <DoctorReferenceField sortBy="doctor__first_name" label="Clinician" />
        <PatientReferenceField
          label="Patient"
          source="patientInfo.id"
          allowEmpty
          sortBy="patientInfo"
        />
        <TextField
          source="platformInfo.os"
          label="OS"
          sortBy="platformInfo__os"
        />
        <TextField
          source="platformInfo.phoneModel"
          label="Model"
          sortBy="platformInfo__phoneModel"
        />
        <FunctionField
          label="Completeness"
          render={(record) =>
            `${R.pathOr(
              "None",
              ["completionSummary", "completionPercent"],
              record
            )} %`
          }
        />
        <TextField source="theragunModel" sortable={false} />
        <TextField source="programName" label="Program" sortable={false} />
        <TextField
          source="bodyAreas"
          label="Muscle Groups"
          sortable={false}
        />
        <TextField source="type" sortable={false} />
        <BooleanField source="is_remote" sortable={false} label="Remote" />
        <TextField
          source="completionSummary.frequencySummary.max"
          label="Max Frequency"
          sortable={false}
        />
        <TextField
          source="completionSummary.frequencySummary.longest"
          label="Longest Frequency"
          sortable={false}
        />
        <NumberField
          source="completionSummary.averageForcePercent"
          label="Average Force Percent"
          sortable={false}
        />
        <NumberField
          source="completionSummary.totalPauseSeconds"
          label="Total Pause Seconds"
          sortBy="completion__totalPauseSeconds"
        />
        <DateField source="startDate" showTime />
        <DateField
          source="completionSummary.finishDate"
          showTime
          label="End Date"
        />
      </Datagrid>
    </List>
  )
);

const editStyles = {
  root: { alignItems: "flex-start" },
  inlineField: {
    display: "inline-block",
    width: "50%",
    whiteSpace: "nowrap",
  },
  inlineField3: {
    display: "inline-block",
    width: "33%",
  },
  inlineField1: {
    display: "inline-block",
  },
};

const TheragunCompletedSessionShow_ = ({ classes, ...props }) => {
  return (
    <SessionShow {...props} aside={<TheragunDevicesAside />} showTitle="Session Info">
      <SimpleShowLayout>
        <TextField source="id" className={classes.inlineField} />
        <DoctorReferenceField
          record={props.record}
          {...props}
          className={classes.inlineField}
          label="Clinician"
        />
        <PatientReferenceField
          label="Patient"
          source="patientInfo.id"
          allowEmpty
          className={classes.inlineField}
        />
        <TextField
          source="platformInfo.os"
          label="OS"
          className={classes.inlineField}
        />
        <TextField
          source="platformInfo.phoneModel"
          label="Model"
          className={classes.inlineField}
        />
        <TextField
          source="platformInfo.appVersion"
          label="App Version"
          className={classes.inlineField}
        />
        <FunctionField
          label="Completness"
          render={(record) =>
            `${R.pathOr(
              "None",
              ["completionSummary", "completionPercent"],
              record
            )} %`
          }
          className={classes.inlineField}
        />
        <TextField source="theragunModel" className={classes.inlineField} />
        <TextField
          source="completionSummary.averageForcePercent"
          label="Average Force Percent"
          className={classes.inlineField}
        />
        <TextField
          source="programName"
          label="Program"
          className={classes.inlineField}
        />
        <TextField
          source="bodyAreas"
          label="Muscle Groups"
          className={classes.inlineField}
        />
        <TextField
          source="completionSummary.frequencySummary.max"
          label="Max Frequency"
          className={classes.inlineField}
        />
        <TextField
          source="completionSummary.frequencySummary.longest"
          label="Longest Frequency"
          className={classes.inlineField}
        />
        <NumberField
          source="completionSummary.totalPauseSeconds"
          label="Total Pause Seconds"
          className={classes.inlineField}
        />
        <DateField
          source="startDate"
          showTime
          className={classes.inlineField}
        />
        <DateField
          source="completionSummary.finishDate"
          showTime
          label="End Date"
          className={classes.inlineField}
        />
        <TextField
          source="completionSummary.cancelReason"
          label="Cancel Reason"
          className={classes.inlineField}
        />
      </SimpleShowLayout>
    </SessionShow>
  );
};

export const TheragunCompletedSessionShow = withStyles(editStyles)(
  TheragunCompletedSessionShow_
);
